export const GUTTER = '1.2rem'
